export class error{
    Code:string;
    Message:string;
    Title:string;
    Show:boolean = false;
}